import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const MicrosoftStaffhubLogoIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M2048 0v2048H0V0h2048zM947 1655q88 0 173-18t153-60 108-113 41-173q0-76-26-133t-71-100-101-76-119-63q-16-8-37-18t-42-23-41-25-32-26q-20-20-28-43t-9-52q0-35 16-58t40-38 55-21 60-6q37 0 70 4t65 14 62 22 63 32q4 2 7 2 14 0 14-14V449q0-9-9-13-29-13-65-21t-76-13-77-7-69-2q-85 0-165 21t-142 65-101 113-38 164q0 70 21 122t58 93 81 71 93 56 92 47 82 48 57 54 22 68q0 36-16 60t-43 38-57 20-62 6q-46 0-85-7t-74-21-69-33-72-46q-4-2-8-2-5 0-9 3t-5 10v236q0 8 7 12 33 18 71 30t78 20 81 11 78 3z" />
    </svg>
  ),
  displayName: 'MicrosoftStaffhubLogoIcon',
});

export default MicrosoftStaffhubLogoIcon;
